<p-fieldset>
  <p-header class="article-title">
    <span class="article-title">{{ "DETACHED-SERVICES" | translate }}</span>
    <div class="header-buttons">
      <button
        class="fab-button primary"
        [disabled]="loading || exportLoading"
        pTooltip="Exportar relatório por cliente"
        tooltipPosition="left"
        (click)="exportByCustomer()"
      >
        <i *ngIf="!exportLoading" class="pi pi-print"></i>
        <i *ngIf="exportLoading" class="pi pi-spin pi-spinner"></i>
      </button>
      <button
        class="fab-button primary"
        [disabled]="loading || exportLoading"
        pTooltip="Exportar relatório simplificado"
        tooltipPosition="left"
        (click)="exportSimple()"
      >
        <i *ngIf="!exportLoading" class="pi pi-file-excel"></i>
        <i *ngIf="exportLoading" class="pi pi-spin pi-spinner"></i>
      </button>
      <button
        class="fab-button primary"
        appFiltersButton
        pTooltip="Exibir/Ocultar Filtros"
        tooltipPosition="left"
      >
        <i class="pi pi-filter"></i>
      </button>
    </div>
  </p-header>
  <form
    class="filters"
    [formGroup]="filterForm"
    (ngSubmit)="searchData()"
    appFilters
  >
    <div class="filter-row">
      <div class="form-control">
        <label for="startDate">{{ "START-DATE" | translate }}</label>
        <p-calendar
          dateFormat="dd/mm/yy"
          formControlName="startDate"
          name="startDate"
          appendTo="body"
          [yearRange]="'2000:2055'"
          [showIcon]="true"
          i18n
        >
        </p-calendar>
      </div>
      <div class="form-control">
        <label for="endDate">{{ "END-DATE" | translate }}</label>
        <p-calendar
          dateFormat="dd/mm/yy"
          formControlName="endDate"
          name="endDate"
          [monthNavigator]="true"
          [yearNavigator]="true"
          appendTo="body"
          [yearRange]="'2000:2055'"
          [showIcon]="true"
          i18n
        >
        </p-calendar>
      </div>
      <div class="buttons">
        <div class="form-button">
          <button
            class="easymarine primary"
            type="button"
            (click)="searchData()"
            [disabled]="loading"
          >
            {{ "FIND" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="table">
    <p-table
      #tt
      [value]="reportData"
      [autoLayout]="true"
      [loading]="loading"
      [paginator]="true"
      [rows]="pageSize"
      [totalRecords]="totalElements"
      [lazy]="true"
      (onLazyLoad)="onLazyLoad($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      [rowsPerPageOptions]="[10, 20, 50, 100]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "PRODUCT" | translate }}</th>
          <th>{{ "PRODUCT-PRICE" | translate }}</th>
          <th>{{ "AVERAGE-VALUE" | translate }}</th>
          <th>{{ "QUANTITY" | translate }}</th>
          <th>{{ "TOTAL" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.productName }}</td>

          <td *ngIf="item.freePrice; else checkSimple">Preço Livre</td>
          <ng-template #checkSimple>
              <td *ngIf="item.simplePrice; else isNotFixed">
                  {{ item.productPrice | dynamicCurrency : currentCurrency }}
                </td>
            </ng-template>
          <ng-template #isNotFixed>
            <td>Preço Variável</td>
          </ng-template>
          
          <td>{{ item.averageValue | dynamicCurrency : currentCurrency }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ item.total | dynamicCurrency : currentCurrency }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9" class="text-center">
            <div class="empty-message-container">
              Não foram encontrados resultados
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-fieldset>
